import { useEffect, useState } from "react";

const secondsUntil = (deadlineMs) => (
  deadlineMs ? Math.max(0, Math.ceil((deadlineMs - Date.now()) / 1000)) : 0
);

/**
 * Whole seconds remaining until an absolute deadline, re-read from the clock
 * every second. Unlike hooks/useCountdown (a decrementing tick counter), this
 * stays correct when the browser throttles or pauses timers in a background
 * tab — exactly what happens while a student switches to their mail app to
 * fetch the code.
 */
const useSecondsUntil = (deadlineMs) => {
  const [seconds, setSeconds] = useState(() => secondsUntil(deadlineMs));

  useEffect(() => {
    setSeconds(secondsUntil(deadlineMs));
    if (!deadlineMs) return undefined;
    const id = setInterval(() => {
      const next = secondsUntil(deadlineMs);
      setSeconds(next);
      if (next <= 0) clearInterval(id);
    }, 1000);
    return () => clearInterval(id);
  }, [deadlineMs]);

  return seconds;
};

export default useSecondsUntil;
